
import React from 'react';
import './Ledbulbhousing.css';
import ledbulbImage from '../../../imgs/Ledbulbhous.webp';

const Ledbulbhousing = () => {
  return (
    <div className='container'>
          <div className="Ledbulbhous-container">
      
      <div className="Ledbulbhous-imag">
        <img src={ledbulbImage} alt="LED Bulb Injection Molding Machine" />
      </div>

      <div className="Ledbulbhous-text">
        <h2>LED Bulb Injection Molding Machine</h2>
        <p>4 Cavity Mold LED Bulb Housing Making Solution</p>
      </div>
      
    </div>
    </div>
     
  );
};

export default Ledbulbhousing;

